import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../directives/TranslatePipe';

export interface FilterOption {
  id: string ;
  label: string;
  icon?: string;
  color?: string;
  isSelected: boolean;
  group: string; //  pour distinguer les catégories (ex: 'status', 'visitorType')
  fieldName: string
}

@Component({
  selector: 'app-multi-criteria-filter',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './multi-criteria-filter.component.html'
})
export class MultiCriteriaFilterComponent {

  private _options: FilterOption[] = [];
  @Input() set options(value: FilterOption[]) {    
    this._options = value.map(opt => ({ ...opt }));   // copie pour ne pas muter l'original
  }
  get options(): FilterOption[] {
    return this._options;   // On retourne la value on-demand
  }


  @Input() multiSelect: boolean = false;
  @Input() clearButtonLabel: string = 'clearFilters';
  @Output() selectionChange = new EventEmitter<FilterOption[]>();


  getButtonClasses(option: FilterOption): string {
    const baseColor = option.color || 'blue';
    if (option.isSelected) {
      let colorClass =  `bg-${baseColor}-600 text-gray-100 border-${baseColor}-700 hover:bg-${baseColor}-700`;
      return colorClass; // `bg-orange-600`;
    } else {
      let colorClass = `bg-${baseColor}-100 hover:bg-${baseColor}-200 text-gray-600 border-${baseColor}-600`;
      return colorClass; 
    }
  }

  toggleOption(clickedOption: FilterOption): void {
    if (!this.multiSelect) {
      this._options.forEach(opt => opt.isSelected = false);
      clickedOption.isSelected = true; 
    }
    else {
      clickedOption.isSelected = !clickedOption.isSelected;
    }

    this._options.filter(opt => opt.id == clickedOption.id).map((opt) => { opt.isSelected = clickedOption.isSelected }); 

    this.selectionChange.emit(this._options);
  }

  clearAll(): void {
    this._options.forEach(opt => opt.isSelected = false);
    this.selectionChange.emit(this._options);
  }
}
